import React from 'react';

const CapricornIcon = ({ width = '80', height = '80', color = '#f1c40f' }) => (
  <svg width={width} height={height} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 50L30 30L50 20L70 30" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M70 30C80 40 80 60 70 70C60 80 40 85 30 70C20 55 20 50 20 50" stroke={color} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default CapricornIcon;
